export default class TimeHelper {
  static format(time: number): string {
    var minutes = Math.floor(time / 60);
    var seconds = time - minutes * 60;
    return minutes + "m " + this.strPadLeft(seconds.toString(), "0", 2) + "s";
  }

  static strPadLeft(string: string, pad: string, length: number): string {
    return (new Array(length + 1).join(pad) + string).slice(-length);
  }
}
